import { render, staticRenderFns } from "./SelectCoursesStandardTable.vue?vue&type=template&id=76aa7d14&scoped=true&lang=pug&"
import script from "./SelectCoursesStandardTable.vue?vue&type=script&lang=ts&"
export * from "./SelectCoursesStandardTable.vue?vue&type=script&lang=ts&"
import style0 from "./SelectCoursesStandardTable.vue?vue&type=style&index=0&id=76aa7d14&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76aa7d14",
  null
  
)

export default component.exports